import { render, staticRenderFns } from "./task-button.vue?vue&type=template&id=70dbc49f&scoped=true"
import script from "./task-button.vue?vue&type=script&lang=js"
export * from "./task-button.vue?vue&type=script&lang=js"
import style0 from "./task-button.vue?vue&type=style&index=0&id=70dbc49f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dbc49f",
  null
  
)

export default component.exports